
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.8291 1.61157L17.8041 5.71991H17.8124C18.7624 6.51157 19.3124 7.67824 19.3124 8.91157V15.7616C19.3124 17.6449 17.8041 19.1616 15.9291 19.1699H5.42075C3.54575 19.1699 2.02075 17.6449 2.02075 15.7616V8.91157C2.02075 7.67824 2.56242 6.50324 3.52075 5.71991L8.49575 1.61157C9.75409 0.569906 11.5708 0.569906 12.8291 1.61157ZM15.9041 17.4949C16.8708 17.4949 17.6458 16.7116 17.6458 15.7532H17.6374V8.90324C17.6374 8.16991 17.3124 7.46991 16.7458 7.00324L11.7624 2.88657C11.1208 2.35324 10.1958 2.35324 9.55409 2.88657L4.57075 7.00324C4.00409 7.46991 3.67909 8.16157 3.67909 8.90324V15.7532C3.67909 16.7199 4.45409 17.4949 5.41242 17.4949H15.9041ZM7.67078 12.4782H13.6624C14.1208 12.4782 14.4958 12.8532 14.4958 13.3116C14.4958 13.7699 14.1208 14.1449 13.6624 14.1449H7.67078C7.21244 14.1449 6.83744 13.7699 6.83744 13.3116C6.83744 12.8532 7.21244 12.4782 7.67078 12.4782Z","fill":"#16171F"}})])
          )
        }
      }
    